import { render, staticRenderFns } from "./MediaSettingsTabs.vue?vue&type=template&id=4a409665&scoped=true"
import script from "./MediaSettingsTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./MediaSettingsTabs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MediaSettingsTabs.vue?vue&type=style&index=0&id=4a409665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a409665",
  null
  
)

export default component.exports